import { Parser } from 'marked';
import { MARKED_OPTIONS, MarkedOptions, MarkedRenderer } from 'ngx-markdown';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = ({ href, title, tokens }) => {
    const titleAttr = title ? ` title="${title}"` : "";
    return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${Parser.parseInline(tokens)}</a>`;

  };

  renderer.image = (token) => {
    const titleAttr = token.title ? ` title="${token.title}"` : "";
    const altAttr = token.text ? ` alt="${token.text}"` : "";
    return `<img src="${token.href}"${altAttr}${titleAttr} class="markdown-img">`;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
  };
}